// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill';
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router/index';
import { StorageService } from './services/storage.service';
import ApiService from './services/api.service';
import { store } from './store/index';
import VueClipboard from 'vue-clipboard2';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueFab from 'vue-float-action-button';
import { Plugins } from '@capacitor/core';
const { SplashScreen } = Plugins;
import VueHead from 'vue-head'



// todo
// cssVars()
Vue.use(VueHead)
Vue.use(BootstrapVue);

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

const options = { name: 'custom', lodash: lodash }; // customize the way you want to call it
Vue.use(VueLodash, options); // options is optional

Vue.use(VueMoment, { moment });

Vue.use(VueFab, {
  //iconType: 'MaterialDesign'
  iconType: 'iconfont',
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App,
  },
  created() {
    Plugins.StatusBar.setBackgroundColor({ color: '#315682' });
    // Set the base URL of the API
    ApiService.init(process.env.VUE_APP_ROOT_API);

    // If token exists set header
    if (StorageService.getToken()) {
      ApiService.setHeaders();
    }
    //this.$store.dispatch('loadingProduct')
  },
  mounted: function () {
    // Hide the splash (you should do this on app launch)
    SplashScreen.hide();
  },
});
